import { render, staticRenderFns } from "./dashboardDialog.vue?vue&type=template&id=5fa3e6cc&scoped=true&"
import script from "./dashboardDialog.vue?vue&type=script&lang=js&"
export * from "./dashboardDialog.vue?vue&type=script&lang=js&"
import style0 from "./dashboardDialog.vue?vue&type=style&index=0&id=5fa3e6cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3e6cc",
  null
  
)

export default component.exports